import React from "react";
import Default from "./Default";

const Document = () => {
    return (
        <Default />
    )
};

export default Document;